module.exports = __webpack_public_path__ + "static/media/redchip_small.f815d837.svg";